__turbopack_context__.v({
  "text": "UnsupportedDevice-module__btIggW__text",
});
